<template>
  <div class="bigBox2">
    <section class="publishHomeWork clear" ref="allHeight">
      <div class="selectHead">
        <span style="font-size: 16px;">布置作业</span>
        <div class="stepBar fr">
          <img src="../../assets/img/step2.png" alt="">
          <p>
            <span class="active">布置对象</span>
            <span class="active">选择内容</span>
            <span>作业留言</span>
          </p>
        </div>
      </div>
      <article class="box menu" ref="leftHeight" v-if="catalog.length">
        <h4 class="tip">单元目录</h4>
        <ul class="first">
          <li v-for="(unit, index) in catalog" :key="index" class="first_li" :class="{'selectedUnit': unit.id == unitId && unit.children.length != 0, 'onlyUnit': unit.id == unitId && unit.children.length == 0}">
            <div @click="toggle(0, unit, [unit.id])" class="gridUnit">
              <p class="" :title="unit.name" :class="{'chooseUnit': unit.id == unitId, 'noChooseUnit': unit.id != unitId}">{{unit.name}}</p>
              <i class="icon arrow-icon" v-show="unit.children.length!=0" :class="{'arrow-up': unit.id == unitId}"></i>
              <span v-show="unit.count>0 && (!unit.checked || unit.children.length == 0)" class="count_style">{{unit.count}}</span>
              <!-- <span>{{unit.checked}}</span> -->
            </div>
            <ul class="second" v-show="unit.checked" v-if="unit.children.length">
              <li v-for="(page, cIndex) in unit.children" :key="cIndex">
                <div @click="toggle(1, page, [unit.id, page.id])" class="gridPage">
                  <p class="" :title="page.name" :class="{'choosePage': page.id == pageId && page.children.length == 0 , 'noChoosePage': page.id != pageId}">{{page.name}}</p>
                  <i class="icon arrow-icon" v-show="page.children!=0" :class="{'arrow-down': page.id == pageId}"></i>
                  <span class="count_style" v-show="page.count>0 && (!page.checked || page.children.length == 0)">{{page.count}}</span>
                </div>
                <ul class="third" v-show="page.checked" v-if="page.children.length">
                  <li v-for="(item, ccIndex) in page.children" :key="ccIndex">
                    <div @click="toggle(2, item, [unit.id, page.id, item.id])" class="gridItem" :title="item.name" :class="{'chooseItem': item.id == itemId, 'noChooseItem': item.id != itemId}">
                      {{item.name}}
                      <span class="count_style" style="right: 17px;" v-show="item.count > 0">{{item.count}}</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </article>

      <div class="box content" ref="boxContent">
        <ul>
          <li v-for="(item, sIndex) in module" :key="sIndex">
            <homeworkcontent :moduleInfo="item.moduleInfo" :resourceList="item.resourceList" :checkedResource="item.checkedResource" :serviceId='serviceId' :packageId='packageId' @increment="increment" :sIndex="sIndex" :cId="cId" :publishedBooks="publishedBooks">
            </homeworkcontent>
          </li>
        </ul>
      </div>
      <div class="noModule" v-show="module.length == 0">
        <img src="./../../assets/img/null.png" alt="">
        <p>没有可以布置的内容！</p>
      </div>
    </section>

    <!-- 计数所选题 -->
    <div class="box footers">
      <!-- <p>共选
			<i style="font-size: 20px; padding: 0 5px;">{{contents.length}}</i>
			条内容,
		</p>
		<p>预计<i style="font-size: 20px; padding: 0 5px;">{{allTimes}}</i>分钟</p> -->
      <span>
        <span @click="back" class="prev">上一步</span>
        <span class="button" :class="{'green': contents.length!=0, 'gray': contents.length==0}" @click="subQuestion">下一步</span>
      </span>
    </div>
  </div>
</template>

<script>
import homeworkcontent from "./../homeWorkContent/homeWorkContent.vue";
import { clientId, brandId } from "./../../config";
import fetch from "./../../fetch";
import { formatDataToMinutes } from "./../../filter";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    homeworkcontent
  },
  data() {
    return {
      catalog: [], // 章节信息!!!!
      package: {},
      module: [],
      resourceName: "",
      cId: "",
      contents: [],
      unitId: 0,
      pageId: 0,
      itemId: 0,
      works: {},
      packageId: 0,
      serviceId: 0,
      subjectId: 0,
      serviceName: "",
      bookName: "",
      selected: false,
      selectedWorkName: "", //存储选中单元
      bookId: "",
      allTimes: 0,
      publishedBooks: []
    };
  },
  created() {
    const that = this;
    this.$nextTick(() => {
      let params = this.$route.query;
      this.bookId = params.bookId;
      this.serviceId = params.serviceId;
      this.packageId = params.packageId;
      this.bookName = params.bookName;
      this.cId = params.cId;
      console.log(params,"2.2")

      this.getRecengBook();
      let catalog = this.getCatalog();
      console.log(catalog);

      let subject = this.getSubject(); // 题目信息!!!!

      if (subject.length) {
        this.contents = this.getWorks().contents;
        this.module = subject;
        this.initQuestion();
      }
      if (catalog.length) {
        this.catalog = catalog;
        this.getCatalogChecked(catalog);
      } else {
        this.getCatalogs();
      }

      if (params.checkedResource) {
        this.routerData(params);
      }
      
      // window.localStorage.setItem("serviceId", this.serviceId)
    });
  },
  watch: {
    $route: "getCatalog"
  },
  methods: {
    ...mapActions([
      "setWorks",
      "setCrumb",
      "removeWorks",
      "setSuject",
      "setCatalog"
    ]),
    ...mapGetters(["getWorks", "getSubject", "getCatalog", "getUser"]),
    initData() {
      let params = {
        workType: this.serviceId,
        packageId: this.packageId,
        workMessageType: 1,
        brandId: brandId,
        sourceType: clientId,
        publishType: 1,
        bookId: this.bookId,
        bookName: this.bookName
      };
      this.setWorks(params);
    },

    getCatalogs() {
      fetch
        .catalogues({ packageId: this.packageId, serviceId: this.serviceId })
        .then(res => {
          if (!res) {
            return false;
          }
          let data = res.data;
          this.catalog = data.catalogues;
          // this.bookName = data.packages.book_name;
          this.bookId = data.packages.package_id;
          this.setWorks({ subjectId: data.packages.subject_id });
          this.catalog.map(item => {
            item.count = 0;
          });
          this.initData();

          this.setCatalog(data.catalogues);
          // let firstSelect = []
          // for(let i=0,len=this.catalog.length;i<len;i++){
          //   firstSelect.push(this.catalog[0].id)

          // }
          this.setCatalogChecked([0, 0, 0, 0], true);
          // this.firstInitPage(data.catalogues);
          // if (this.$route.query.isFirst) {
          //   this.firstInitPage(data.catalogues);
          // }
        });
    },
    firstInitPage(catalogues) {
      if (!catalogues || !catalogues.length) return false;
      let first;
      let cId = 0;
      let name = "";
      let contents = this.getWorks().contents;
      if (contents && contents.length > 0) {
        cId = this.getSubject()[0].moduleInfo.packageCatalogueId; //获取到最后一次显示章节内容的ID,下次显示对应章节
        let _this = this;
        // 默认打开选中的第一个,下面逻辑处理显示对应章节
        catalogues.map((catalog, index) => {
          if (catalog.children.length == 0) {
            if (catalog.id == cId) {
              name = catalog.name;
              _this.unitId = catalog.id;
            }
          } else {
            catalog.children.map((catalog2, index2) => {
              if (catalog2.children.length == 0) {
                if (catalog2.id == cId) {
                  name = catalog2.name;
                  _this.unitId = catalog.id;
                  _this.pageId = catalog2.id;
                }
              } else {
                catalog2.children.map((catalog3, index3) => {
                  if (catalog3.children.length == 0) {
                    if (catalog3.id == cId) {
                      name = catalog3.name;
                      _this.unitId = catalog.id;
                      _this.pageId = catalog2.id;
                      _this.itemId = catalog3.id;
                    }
                  }
                });
              }
            });
          }
        });
        !name && (cId = 0);
      } else {
        first = catalogues[0];
        this.unitId = first.id;
        if (!first.children.length) {
          cId = first.id;
          name = first.name;
        } else {
          let second = first.children[0];
          this.pageId = second.id;
          if (!second.children.length) {
            cId = second.id;
            name = second.name;
          } else {
            let third = second.children[0];
            cId = third.id;
            name = third.name;
            this.itemId = cId;
          }
        }
      }
      this.selectedWorkName = name; //选中单元赋值
      this.cId = cId;
      this.getResources(cId);
    },
    getRecengBook() {
      let params = {
        bookId: this.packageId,
        userId: this.getUser().userId
      };
      fetch.getRecentPublishBokk(params).then(res => {
        if (!res) {
          return false;
        }
        this.publishedBooks = res.data;
      });
    },
    getCatalogChecked(data) {
      for (let index = 0, len = data.length; index < len; index++) {
        let item = data[index];
        if (item.checked && !item.children.length) {
          this.cId = item.id;
        } else if (item.children.length) {
          this.getCatalogChecked(item.children);
        }
      }
    },
    setCatalogChecked(arr, isFirst) {
      let catalog = this.catalog;
      this.mapCatalog(catalog, arr, 0, isFirst);
      this.catalog = [...catalog];
    },
    mapCatalog(catalogItem, arr, i, isFirst) {
      for (let index = 0, len = catalogItem.length; index < len; index++) {
        let item = catalogItem[index];
        item.checked = false;
        if (item.id == arr[i] || index == arr[i]) {
          ++i;
          item.checked = true;
        }

        if (index == 0 && isFirst && !item.children.length) {
          this.cId = item.id;
          this.getResources(item.id);
        } else if (item.children && item.children.length > 0) {
          this.mapCatalog(item.children, arr, i, isFirst);
        }

        if (item.id == arr[i] || index == arr[i]) {
          --i;
          break;
        }
      }
    },
    toggle(typeId, item, arr) {
      if (typeId == 1) {
        this.pageId = item.id;
        this.setCatalogChecked(arr);
      } else if (typeId == 0) {
        this.unitId = item.id;
        this.setCatalogChecked(arr);
      } else if (typeId == 2) {
        this.itemId = item.id;
        this.setCatalogChecked(arr);
      }
      this.setCatalogChecked(arr);
      if (item.children.length) {
        return false;
      }
      this.selectedWorkName = item.name; //选中单元赋值
      this.selected = true;
      this.resourceName = item.name;
      this.cId = item.id; //每次点完的cid要保存到一个地方
      this.module = [];
      this.getResources(item.id);
    },
    getResources(cId) {
      let params = {
        packageId: this.packageId,
        cId: cId,
        moduleIds: "10,15,30,66,124,123,127"
      };
      fetch.resources(params).then(res => {
        if (!res) {
          return false;
        }
        if (res) {
          this.module = res.data;
          this.setSuject([]);
          // this.setWorks({ contents: [] });
          // this.contents = [];
          this.initQuestion();
        }
      });
    },
    initQuestion() {
      let contents = this.contents;
      if (!contents) {
        return false;
      }
      this.allTimes = 0;
      contents.map(item => {
        if (item.refLong) {
          this.allTimes += item.refLong;
        }
        this.getNewData(
          {
            moduleId: item.moduleId,
            versionId: item.versionId,
            parentVersionId: item.parentVersionId,
            requirementContent: item.requirementContent,
            itemCount: item.itemCount,
            defAnswerTime: item.defAnswerTime,
            refLong: item.refLong,
            bigItemCount: item.bigItemCount,
            sentenceCount: item.sentenceCount,
            resourceName: item.resourceName,
            resourceType: item.resourceType
          },
          true
        );
      });
    },
    subQuestion() {
      if (!this.contents.length) {
        this.$toast("请选择布置内容");
        return false;
      }
      let title = this.addCatalogCount(0);
      let params = {
        selectedWorkName: title,
        type: 1,
        serviceId: this.serviceId
      };
      this.setWorks({ allTimes: this.allTimes });
      this.$router.push({ path: "publishBooks", query: params });
    },

    increment(res) {
      let _this = this;
      let selectContents = this.contents;
      let contents = [];
      let params = {
        packageId: this.packageId,
        cId: this.cId,
        checkedResource: "",
        requirementContent: "",
        workTag: 1,
        refLong: res.refLong,
        bigItemCount: res.bigItemCount,
        itemCount: res.itemCount,
        sentenceCount: res.sentenceCount,
        second: res.second,
        cId: this.cId
      }
      selectContents.map(item => {
        const _this = this;
        if ( item.resourceType == res.resourceType && item.resourceName == res.resourceName && item.versionId == res.versionId ) {
          if (res.isChecked) {
            this.allTimes -= item.refLong;
            if (res.resourceType === "992a5055-e9d0-453f-ab40-666b4d7030bb") {
              item.refLong = formatDataToMinutes(
                item.sentenceCount * res.second * res.requirementContent.readtimes
              );
            } else {
              item.refLong = formatDataToMinutes(
                item.itemCount * res.second * res.requirementContent.readtimes
              );
            }

            // item.refLong = formatDataToMinutes(res.requirementContent.readtimes * res.second * item.count);
          }
          Object.assign(params, item);
        } else {
          contents.push(item);
        }
      });

      // res.refLong = params.refLong;
      // res.count = params.count;
      // res.sentenceCount = params.sentenceCount;
      if (res.isChecked) {
        if (this.contents.length >= 20 && res.change) {
          this.$toast("您最多可以勾选20条内容！", "error");
          return false;
        }
        if (res.refLong) {
          this.allTimes += params.refLong;
        }
        this.getNewData(res, true, (item, moduleId, index) => {
          params.moduleId = moduleId;
          params.requirementContent =
            '{"readtimes":' +
            res.requirementContent.readtimes +
            ', "speekingtype":' +
            res.requirementContent.speekingtype +
            "}";
          Object.assign(params, item);
          contents.push(params);

          if (res.change) {
            _this.addCatalogCount(_this.cId, 1);
          }
        });
      } else {
        this.getNewData(res, false);
        this.addCatalogCount(this.cId, -1);
        if (params.refLong) {
          this.allTimes -= params.refLong;
        }
      }
      this.setWorks({ contents: [] });
      this.setWorks({ contents: contents });
      this.contents = contents;
      this.catalogCount();
    },
    catalogCount() {
      let catalog = this.catalog;
      if (this.contents.length == 0) {
        catalog.map(item => {
          item.count = 0;
          item.children.map(item2 => {
            item2.count = 0;
            item2.children.map(item3 => {
              item3.count = 0;
            });
          });
        });
      } else {
        this.contents.map((res, index) => {
          let cid = res.cId;
          catalog.map(item => {
            if (index == 0) item.count = 0;
            if (!item.children.length) {
              if (item.id === cid) {
                item.count++;
              }
            } else {
              let children = item.children;
              children.map(citem => {
                if (index == 0) citem.count = 0;
                if (!citem.children.length) {
                  if (cid === citem.id) {
                    item.count++;
                    if (!citem.count) {
                      citem.count = 0;
                    }
                    citem.count++;
                  }
                } else {
                  let grandson = citem.children;
                  grandson.map(gitem => {
                    if (index == 0) gitem.count = 0;
                    if (!gitem.children.length) {
                      if (cid == gitem.id) {
                        !citem.count && (citem.count = 0);
                        citem.count++;
                        item.count++;
                        if (!gitem.count) {
                          gitem.count = 0;
                        }
                        gitem.count++;
                      }
                    }
                  });
                }
              });
            }
          });
        });
      }
      this.catalog = catalog;
      this.setCatalog(this.catalog);
    },
    addCatalogCount(cid, num) {
      let title = "";
      this.catalog.map(item => {
        // item.count = 0;
        if (!item.children.length) {
          if (item.id === cid) {
            item.count += num;
          }
          if (item.count) {
            title += item.name + ",";
          }
        } else {
          let children = item.children;
          children.map(citem => {
            if (!citem.children.length) {
              if (cid === citem.id) {
                item.count += num;
                if (!citem.count) {
                  citem.count = 0;
                }
                citem.count += num;
              }
              if (citem.count) {
                title += citem.name + ",";
              }
            } else {
              let grandson = citem.children;
              grandson.map(gitem => {
                if (!gitem.children.length) {
                  if (cid == gitem.id) {
                    !citem.count && (citem.count = 0);
                    citem.count += num;
                    item.count += num;
                    if (!gitem.count) {
                      gitem.count = 0;
                    }
                    gitem.count += num;
                  }
                }
                if (gitem.count) {
                  title += gitem.name + ",";
                }
              });
            }
          });
        }
      });
      this.setCatalog(this.catalog);
      return title;
    },
    getNewData(res, isChecked, cb) {
      let newData = [];
      this.module.map((item, index) => {
        let moduleInfo = item.moduleInfo;
        // if (moduleInfo.moduleId != 30) {
        let resourceList = item.resourceList;
        let obj = {};
        obj.moduleInfo = moduleInfo;
        obj.resourceList = [];
        resourceList.map((rItem, rIndex) => {
          if ( rItem.resourceType == res.resourceType && rItem.resourceName == res.resourceName && rItem.versionId == res.versionId && rItem.parentVersionId == res.parentVersionId) {
            rItem.isChecked = isChecked;
            rItem.readtimes = res.requirementContent.readtimes;
            rItem.speekingtype = res.requirementContent.speekingtype;
            rItem.itemCount = res.itemCount;
            rItem.refLong = res.refLong;
            rItem.bigItemCount = res.bigItemCount;
            rItem.sentenceCount = res.sentenceCount;
            rItem.checkedResource = res.checkedResource || "";
            rItem.defAnswerTime = res.defAnswerTime;
            rItem.workScore = res.refScore;
            if (cb) {
              cb(rItem, moduleInfo.moduleId, rIndex);
            }
          }
          obj.resourceList.push(rItem);
        });
        newData.push(obj);
        // }
      });
      this.setSuject([]);
      this.setSuject(newData);
      this.module = newData;
    },
    routerData(params) {
      let contents = this.contents;
      console.log(params, "%^(&*())))__)");
      let checkedResource = params.checkedResource.split(",");
      for (let i = 0, len = contents.length; i < len; i++) {
        let item = contents[i];
        if (item.resourceType == params.resourceType && item.moduleId == params.moduleId && item.versionId == params.versionId && item.parentVersionId == params.parentVersionId) {
          item.itemCount =
            item.resourceType == "fcfd6131-cdb6-4eb8-9cb9-031f710a8f15"
              ? params.bigQuesCount
              : params.count;
          item.bigItemCount = params.bigQuesCount;
          item.sentenceCount = params.sentenceCount;
          item.checkedResource = checkedResource.join(",");
          item.workScore = params.refScore;
          if (item.resourceType == '992a5055-e9d0-453f-ab40-666b4d7030bb') {
            item.refLong = Math.ceil(
              item.sentenceCount * item.defAnswerTime * item.readtimes / 60
            );
          } else {
            item.refLong = Math.ceil(
              item.itemCount * item.defAnswerTime * item.readtimes / 60
            );
          }
        }
        this.getNewData(item, true);
      }
      this.setWorks({ contents: [] });
      this.setWorks({ contents: contents });
    },
    back() {
      let classIds = JSON.parse(window.sessionStorage.getItem("classIds"))
        .classId;
      this.$router.push({
        path: "setHomework",
        query: { bookType: 1, classIdstr: classIds }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// publishHomeWork.vue?678c8cea